import DeleteModal from 'asset-actions-lib/components/modals/DeleteModal';
import { ACTION_IDS } from 'asset-actions-lib/constants/actionIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteModalThatBreaksCyclicDependency = props => {
  return /*#__PURE__*/_jsx(DeleteModal, Object.assign({}, props));
};
export const DELETE_ACTION = {
  id: ACTION_IDS.DELETE,
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "assetActionsLib.sharedActions.delete"
  }),
  onConfirm: () => {},
  // This is necessary to break a cyclic dependency
  // https://mermaid.live/edit#pako:eNpVkcFuwjAMhl-l8rm0SQmh9IDExhUu22nLDlFjoFOboMbVYIh3X0pbpN3y2_7s3_ENSmcQCjjU7qc86Zai9xdl98vPb5-Wrjk7i5Z82jija59usUbCXS8S8pevvjKazdbRni-VDYqzAbSedM8ZPOiupk1JVYhNDGcjJAZI_Id88IFmZEKLfuYTFdEs6dlx3mjUEl4o3XiP06zXIfbkJp9MWYihwbbRlQmL35SNIgV0wgYVFOE5elag7D2U6o7c29WWUFDbYQzd2WjCbaWPrW6mYOu64wmKQ_ikoM7afjj3TAYJxQ0uUOQ8kXk-l4zlfMXniyyGKxQ8Y8mCi5VgMmdCMi7uMfw-GrBEiozNpeQhlWV8IWNAU5Frd8PdHue7_wG2G5QI
  // https://product.hubteam.com/docs/frontend/docs/cyclic-imports.html#defer-references
  ModalOrPanel: DeleteModalThatBreaksCyclicDependency,
  actionGroup: 2
};